<template>
  <res-dialog
    :title="title"
    :showDialog="showDialog"
    :saveButtonOnly="true"
    :cancelButtonOnly="true"
    :smallTitleIcon="true"
    :maxWidth="700"
    :setWidth="700"
    backgroundColor="#efefef"
    :iconColor="'white'"
    iconTitle="mdi-calendar-blank-multiple"
    :showTitleIcon="true"
    titleClass="resBlue darken-1 white--text"
    @cancel="close"
  >
    <res-dialog
      title="Are you sure?"
      :showDialog="showConfirmDelete"
      :smallTitleIcon="true"
      :maxWidth="700"
      :setWidth="700"
      backgroundColor="white"
      saveButtonText="Yes"
      cancelButtonText="Cancel"
      :iconColor="'white'"
      iconTitle="mdi-alert"
      :showTitleIcon="true"
      titleClass="resBlue darken-1 white--text"
      @save="confirmDelete"
      @cancel="cancelDelete"
    >
      <div>
        <br />
        <div>Are you sure you want to permanently delete this comment?</div>
        <br />
      </div>
    </res-dialog>
    <v-container>
      <v-card-text class="dialog-base">
        <v-list three-line>
          <div class="separator py-2">FLAGGED / RESOLVED</div>
          <span
            class="center"
            v-show="
              !flaggedResolvedComments || flaggedResolvedComments.length <= 0
            "
            >NO FLAGS OR RESOLVED COMMENTS</span
          >
          <template
            v-show="
              flaggedResolvedComments && flaggedResolvedComments.length > 0
            "
            v-for="item in flaggedResolvedComments"
          >
            <v-card-text
              :key="item.commentId"
              class="comment-card px-0 py-0 my-2"
            >
              <v-list-item class="rounded-lg">
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>{{ item.user }}</strong>
                    {{
                      localizeDate(item.timestamp)
                        | moment("MM/DD/YYYY hh:mm:ss A")
                    }}
                    <v-menu
                      v-if="!readonly"
                      close-on-click
                      v-model="item.menuOpen"
                      right
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          :disabled="!isEditable(item)"
                          :color="menuColor(item)"
                          :class="menuTextColor(item)"
                          class="ellipses-control"
                          >{{ menuIcon(item) }}</v-icon
                        >
                      </template>
                      <v-list class="ellipses-control-option-list">
                        <v-list-item @click="beginEdit(item)">
                          <v-list-item-title class="ellipses-control-option"
                            >Edit</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item>---------------</v-list-item>
                        <v-list-item @click="beginDelete(item)">
                          <v-list-item-title class="ellipses-control-option"
                            >Delete</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <span
                      class="comment-flag rounded-lg mr-3 pr-2"
                      :class="item.resolved ? 'flag-resolved' : 'flag-active'"
                    >
                      <v-icon
                        class="pl-1"
                        :color="
                          item.resolved
                            ? 'var(--v-resGreen-base)'
                            : 'var(--v-resRed-base)'
                        "
                        >mdi-flag</v-icon
                      >
                      {{ item.resolved ? "Resolved" : "Flagged" }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="py-2 wrap-text">
                    {{ item.text }}
                  </v-list-item-subtitle>
                  <div class="d-flex justify-end">
                    <v-btn
                      @click="startWritingResolutionToComment(item.commentId)"
                      v-if="!item.resolved && !readonly"
                      color="resGreen darken-1 white--text"
                      class="mr-2"
                      >Resolve</v-btn
                    >
                    <v-btn
                      @click="startWritingReplyToComment(item.commentId)"
                      color="resBlue darken-1 white--text"
                      v-if="!readonly"
                      textColor="white"
                      >Reply</v-btn
                    >
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
            <template v-for="subItem in item.replies">
              <v-card-text
                :key="subItem.commentId"
                class="comment-card reply-card ml-5 px-0 py-0 my-2"
              >
                <v-list-item class="rounded-lg">
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong
                        ><span class="resolution">{{
                          subItem.type == "Flag Resolution" ? "Resolved By" : ""
                        }}</span>
                        {{ subItem.user }}</strong
                      >
                      {{
                        localizeDate(subItem.timestamp)
                          | moment("MM/DD/YYYY hh:mm:ss A")
                      }}
                      <v-menu
                        v-if="!readonly"
                        close-on-click
                        v-model="subItem.menuOpen"
                        right
                        offset-y
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            :disabled="!isEditable(subItem)"
                            :color="menuColor(subItem)"
                            :class="menuTextColor(subItem)"
                            class="ellipses-control"
                            >{{ menuIcon(subItem) }}</v-icon
                          >
                        </template>
                        <v-list class="ellipses-control-option-list">
                          <v-list-item @click="beginEdit(subItem)">
                            <v-list-item-title class="ellipses-control-option"
                              >Edit</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item>---------------</v-list-item>
                          <v-list-item @click="beginDelete(subItem)">
                            <v-list-item-title class="ellipses-control-option"
                              >Delete</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-title>
                    <v-list-item-subtitle class="py-2 wrap-text">{{
                      subItem.text
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
            </template>
          </template>
          <div class="separator py-2">OTHER COMMENTS</div>
          <span
            class="center"
            v-show="!otherComments || otherComments.length <= 0"
            >NO OTHER COMMENTS</span
          >
          <template
            v-show="otherComments && otherComments.length > 0"
            v-for="item in otherComments"
          >
            <v-card-text
              :key="item.commentId"
              class="comment-card px-0 py-0 my-2"
            >
              <v-list-item class="rounded-lg">
                <v-list-item-content>
                  <v-list-item-title>
                    <strong>{{ item.user }}</strong>
                    {{
                      localizeDate(item.timestamp)
                        | moment("MM/DD/YYYY hh:mm:ss A")
                    }}
                    <v-menu
                      v-if="!readonly"
                      close-on-click
                      v-model="item.menuOpen"
                      right
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-on="on"
                          :disabled="!isEditable(item)"
                          :color="menuColor(item)"
                          :class="menuTextColor(item)"
                          class="ellipses-control"
                          >{{ menuIcon(item) }}</v-icon
                        >
                      </template>
                      <v-list class="ellipses-control-option-list">
                        <v-list-item @click="beginEdit(item)">
                          <v-list-item-title class="ellipses-control-option"
                            >Edit</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item>---------------</v-list-item>
                        <v-list-item @click="beginDelete(item)">
                          <v-list-item-title class="ellipses-control-option"
                            >Delete</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-title>
                  <v-list-item-subtitle class="py-2 wrap-text">
                    {{ item.text }}
                  </v-list-item-subtitle>
                  <div class="d-flex justify-end">
                    <v-btn
                      @click="startWritingReplyToComment(item.commentId)"
                      v-if="!readonly"
                      color="resBlue darken-1 white--text"
                      >Reply</v-btn
                    >
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
            <template v-for="subItem in item.replies">
              <v-card-text
                :key="subItem.commentId"
                class="comment-card reply-card ml-5 px-0 py-0 my-2"
              >
                <v-list-item class="rounded-lg">
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong
                        ><span class="resolution">{{
                          subItem.type == "Flag Resolution" ? "Resolved By" : ""
                        }}</span>
                        {{ subItem.user }}</strong
                      >
                      {{
                        localizeDate(subItem.timestamp)
                          | moment("MM/DD/YYYY hh:mm:ss A")
                      }}
                      <v-menu
                        v-if="!readonly"
                        close-on-click
                        v-model="subItem.menuOpen"
                        right
                        offset-y
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            :disabled="!isEditable(subItem)"
                            :color="menuColor(subItem)"
                            :class="menuTextColor(subItem)"
                            class="ellipses-control"
                            >{{ menuIcon(subItem) }}</v-icon
                          >
                        </template>
                        <v-list class="ellipses-control-option-list">
                          <v-list-item @click="beginEdit(subItem)">
                            <v-list-item-title class="ellipses-control-option"
                              >Edit</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item>---------------</v-list-item>
                          <v-list-item @click="beginDelete(subItem)">
                            <v-list-item-title class="ellipses-control-option"
                              >Delete</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-title>
                    <v-list-item-subtitle class="py-2 wrap-text">{{
                      subItem.text
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
            </template>
          </template>
        </v-list>
      </v-card-text>
      <v-card-text v-if="writingComment" class="new-comment py-0">
        <v-textarea
          v-model="commentText"
          id="commentInput"
          v-if="!readonly"
          ref="commentInput"
          auto-grow
          counter
          :rules="[
            (v) =>
              (v || '').length <= 400 ||
              'Comments must be 400 characters or less.',
            (v) =>
              (v || '').trim().length >= 3 ||
              'Comments must be 3 characters or more.',
          ]"
          rows="1"
        >
        </v-textarea>
      </v-card-text>
    </v-container>
    <v-checkbox
      v-if="
        writingComment &&
        !resolvingComment &&
        !replyingToCommentId &&
        !anyCommentFlagged &&
        !editingCommentId
      "
      class="py-0 my-0 pull-right"
      label="Flagged Comment"
      v-model="flagNewComment"
    ></v-checkbox>
    <br />
    <v-card-actions class="px-4 pt-0 pb-4 d-flex justify-end full-width">
      <v-btn
        v-if="!readonly && writingComment"
        outlined
        @click="stopWritingComment"
        color="resBlue darken-1 white--text"
        >Cancel</v-btn
      >
      <v-btn
        v-if="
          !readonly && writingComment && !resolvingComment && !editingCommentId
        "
        @click="saveNewComment"
        color="resBlue darken-1 white--text"
        >Save</v-btn
      >
      <v-btn
        v-if="
          !readonly && writingComment && !resolvingComment && editingCommentId
        "
        @click="confirmEdit"
        color="resBlue darken-1 white--text"
        >Save Changes</v-btn
      >
      <v-btn
        v-if="!readonly && resolvingComment"
        @click="resolveComment"
        color="resBlue darken-1 white--text"
        >Resolve</v-btn
      >
      <v-btn
        v-if="!readonly && !writingComment"
        @click="startWritingComment"
        color="resBlue darken-1 white--text"
        >New Comment</v-btn
      >
    </v-card-actions>
  </res-dialog>
</template>

<script>
import ResDialog from "@/components/base/ResDialog.vue";
import Localizable from "@/mixins/Localizable.js";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    ResDialog,
  },
  mixins: [Localizable],
  data: function () {
    return {
      setHeight: "30",
      comments: [],
      writingComment: false,
      resolvingComment: false,
      commentText: null,
      flagNewComment: false,
      replyingToCommentId: null,
      resolvingCommentId: null,
      editingCommentId: null,
      deletingCommentId: null,
      showConfirmDelete: false,
    };
  },
  props: {
    height: {
      type: Number,
    },
    maxWidth: {
      type: Number,
    },
    showDialog: {
      type: Boolean,
    },
    width: {
      type: Number,
    },
    description: {
      type: String,
    },
    title: {
      type: String,
    },
    commentService: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions(["changeLoading"]),
    close() {
      this.$emit("close", true);
    },
    startWritingComment() {
      this.writingComment = true;
      this.resolvingComment = false;
      this.commentText = "";
      this.flagNewComment = false;
      this.replyingToCommentId = null;
      this.resolvingCommentId = null;
      this.editingCommentId = null;
      setTimeout(() => {
        document.querySelector("#commentInput").scrollIntoView();
        document.querySelector("#commentInput").click();
      });
    },
    stopWritingComment() {
      this.writingComment = false;
      this.resolvingComment = false;
      this.replyingToCommentId = null;
      this.resolvingCommentId = null;
      this.editingCommentId = null;
      this.deletingCommentId = null;
      this.commentText = "";
      this.showConfirmDelete = false;
      this.flagNewComment = false;
    },
    startWritingReplyToComment(commentId) {
      this.startWritingComment();
      this.replyingToCommentId = commentId;
    },
    startWritingResolutionToComment(commentId) {
      this.startWritingComment();
      this.resolvingCommentId = commentId;
      this.resolvingComment = true;
    },
    async saveNewComment() {
      if (!this.isValid()) {
        return;
      }
      this.changeLoading(true);
      await this.commentService.createComment(
        this.commentText,
        this.flagNewComment,
        this.replyingToCommentId
      );
      this.stopWritingComment();
      this.getComments();
      this.$emit("commentEntered", true); // this is used to refresh the resolved/unresolved icon
    },
    async resolveComment() {
      if (!this.isValid()) {
        return;
      }
      this.changeLoading(true);
      await this.commentService.resolveComment(
        this.resolvingCommentId,
        this.commentText
      );
      this.stopWritingComment();
      this.getComments();
      this.$emit("commentEntered", true); // this is used to refresh the resolved/unresolved icon
    },
    beginEdit(comment) {
      if (!this.isEditable(comment)) {
        return;
      }
      this.startWritingComment();
      this.editingCommentId = comment.commentId;
      this.commentText = comment.text;
    },
    async confirmEdit() {
      if (!this.isValid()) {
        return;
      }
      this.changeLoading(true);
      await this.commentService.editComment(
        this.editingCommentId,
        this.commentText
      );
      this.stopWritingComment();
      this.getComments();
      this.$emit("commentEntered", true); // this is used to refresh the resolved/unresolved icon
    },
    beginDelete(comment) {
      if (!this.isEditable(comment)) {
        return;
      }
      this.deletingCommentId = comment.commentId;
      this.showConfirmDelete = true;
    },
    async confirmDelete() {
      this.changeLoading(true);
      await this.commentService.deleteComment(this.deletingCommentId);
      this.stopWritingComment();
      this.getComments();
      this.$emit("commentEntered", true); // this is used to refresh the resolved/unresolved icon
    },
    cancelDelete() {
      this.stopWritingComment();
    },
    async getComments() {
      this.changeLoading(true);
      if (!this.commentService) {
        this.changeLoading(false);
        return;
      }
      let response = await this.commentService.getComments();
      if (response && response.data) {
        this.comments = response.data.commentList || [];
      } else {
        this.comments = [];
      }
      this.changeLoading(false);
    },
    isValid() {
      return !this.currentLoading && this.$refs.commentInput.validate();
    },
    updateMenuState(isOpen, comment) {
      comment.menuOpen = isOpen;
    },
    isEditable(comment) {
      return (
        !(comment.replies && comment.replies.length) && comment.createdByUser
      );
    },
    menuIcon(comment) {
      return comment.menuOpen
        ? "mdi-dots-horizontal-circle"
        : this.isEditable(comment)
        ? "mdi-dots-horizontal"
        : "mdi-dots-horizontal-circle";
    },
    menuColor(comment) {
      return this.isEditable(comment)
        ? comment.menuOpen
          ? "resBlue darken-1"
          : "white"
        : "white";
    },
    menuTextColor(comment) {
      return this.isEditable(comment)
        ? comment.menuOpen
          ? "white--text"
          : "resBlue--text text--darken-1"
        : "white--text";
    },
  },
  computed: {
    ...mapGetters(["currentLoading"]),
    calculateHeight() {
      return "height:" + this.setHeight + "px";
    },
    flaggedResolvedComments() {
      return this.comments.filter((comment) => comment.type == "Flag");
    },
    anyCommentFlagged() {
      let anyFlagged =
        this.flaggedResolvedComments.filter(
          (comment) => comment.type == "Flag" && !comment.resolved
        ).length > 0;
      return anyFlagged;
    },
    commentActivityExists() {
      let activity = this.comments.length > 0;
      return activity;
    },
    otherComments() {
      return this.comments.filter((comment) => comment.type !== "Flag");
    },
  },
  watch: {
    showDialog: function (newVal) {
      if (newVal) {
        // clear previous comments because this instance is shared
        this.comments = [];
        this.getComments();
      }
    },
    anyCommentFlagged: function (newVal) {
      this.$emit("flagged", newVal);
    },
    commentActivityExists: function (newVal) {
      this.$emit("activity", newVal);
    },
  },
  async mounted() {
    this.getComments();
  },
};
</script>

<style scoped>
.resolution {
  color: var(--v-resGreen-base);
}
.new-comment,
.comment-card {
  background-color: white !important;
  border-radius: 5px;
}
.comment-card * {
  background-color: white !important;
}
.ellipses-control {
  float: right;
}
.comment-flag {
  border: 2px solid;
  float: right;
}
.comment-flag i {
  background-color: rgba(0, 0, 0, 0) !important;
}
.flag-resolved {
  background-color: var(--v-resGreen-lighten4) !important;
  border-color: var(--v-resGreen-base);
  color: var(--v-resGreen-base);
}
.flag-active {
  background-color: var(--v-resRed-lighten4) !important;
  border-color: var(--v-resRed-base);
  color: var(--v-resRed-base);
}
.new-comment {
  border: 2px solid var(--v-resBlue-darken1);
}
.dialog-base {
  padding-top: 0;
}
.dialog-base * {
  background-color: #efefef;
}
.full-width {
  width: 100%;
}
.center {
  text-align: center;
  display: block;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #000;
}

.separator:not(:empty)::before {
  margin-right: 0.25em;
}

.separator:not(:empty)::after {
  margin-left: 0.25em;
}
.pull-right {
  float: right;
}
.wrap-text {
  -webkit-line-clamp: unset !important;
}
</style>
